import type { ChangeEvent } from 'react';
import { useId, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useLocales } from 'src/locales/use-locales';

export function LanguageSelect() {
  const { t } = useTranslation('footer');
  const { allLangs, currentLang, onChangeLang } = useLocales();
  const selectId = useId();

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLSelectElement>) => {
      const selected = allLangs.find((lang) => lang.value === event.target.value);

      if (selected) {
        onChangeLang(selected.value);
      }
    },
    [allLangs, onChangeLang]
  );

  return (
    <div className="lang-switch">
      <label htmlFor={selectId}>{t('language')}</label>
      <select id={selectId} onChange={handleChange} value={currentLang.value}>
        {allLangs.map((lang) => (
          <option key={lang.value} value={lang.value}>
            {lang.label}
          </option>
        ))}
      </select>
    </div>
  );
}
